import { assertNever } from "@impero-com/common/utils/obj";

import { TActExportRow, TActTableRow } from "api/generated/model";

export function getCurrentStepDueDate(resource: TActTableRow | TActExportRow) {
    switch (resource.status) {
        case "responsible":
            return resource.responsibleInfo.dueDate;
        case "firstReviewer":
            return resource.firstReviewInfo?.dueDate;
        case "secondReviewer":
            return resource.secondReviewInfo?.dueDate;
        case "completed":
            return undefined;
        default:
            return assertNever(resource.status);
    }
}

export function isActivityOverdue(resource: TActTableRow | TActExportRow) {
    const dueDateString = getCurrentStepDueDate(resource);
    if (!dueDateString) {
        return false;
    }
    const dueDate = new Date(dueDateString);
    return Date.now() > dueDate.valueOf();
}
